// extracted by mini-css-extract-plugin
export default {"main":"Consulting_main__WbkMK","cover":"Consulting_cover__TvMFl","flex_col":"Consulting_flex_col__FZ+2C"};